/** Project a clip-time window onto the source-video axis, split per kept
 *  interval — one bar segment per interval the window overlaps. Used to
 *  draw layer lanes on the same axis as the timeline ruler. */
export function layerWindowToVideoSegments(
  start: number,
  end: number,
  intervals: Array<{ startTime: number; endTime: number }>,
): Array<{ videoStart: number; videoEnd: number }> {
  const segments: Array<{ videoStart: number; videoEnd: number }> = [];
  let acc = 0;
  for (const iv of intervals) {
    const len = iv.endTime - iv.startTime;
    const segStart = Math.max(start, acc);
    const segEnd = Math.min(end, acc + len);
    if (segEnd > segStart) {
      segments.push({
        videoStart: iv.startTime + (segStart - acc),
        videoEnd: iv.startTime + (segEnd - acc),
      });
    }
    acc += len;
  }
  return segments;
}
